import React from "react";
import "./header.scss";

const object1 = sessionStorage.getItem("Product_FIRSTNAME");
console.log("firstName",object1);
const Header = () => {
  return (
    <div className="heading_container">
      <div className="hmain">
        {/* <img src={require("../../../images/ltimlogo.png")} alt="" /> */}
        <div className="app_title">Product IT Assesment</div>
        <div className="greet_user">
          <span>Welcome </span>
          <span>{sessionStorage.getItem("Product_FIRSTNAME")}</span>
        </div>
      </div>
      <div className="underlines"></div>
    </div>
  );
};

export default Header;
